/**
 * @experimental
 * at the moment this is very much the same as the base-video-player but this might not be the case forever,
 * thats why i decided to add a copy
 */
(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    if (customElements.get('base-audio-player') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
            display: inline-block;
        }
        [part="wrapper"] {
            position: relative;
            display: grid;
            grid-template-areas: "a";
            min-width: 320px;
            min-height: 100px;
        }
        [part="click-target"] {
            position: absolute;
            z-index: 1;
            inset: 0;
        }
        [part="cover"] {
            position: relative;
            z-index: 0;
            grid-area: a;
        }
        [part="internal-player"] {
            position: relative;
            z-index: 2;
            grid-area: a;
            justify-self: stretch;
            align-self: end;
            opacity: 0;
            pointer-events: none;
        }
        [part="internal-player"] ::slotted(audio) {
            display: block;
            width: 100%;
        }
        :host([playing]) [part="internal-player"] {
            opacity: 1;
            pointer-events: all;
        }
        [part="play-button-container"] {
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            position: absolute;
            z-index: 1;
            transition:
                transform .5s ease,
                opacity .25s ease;
        }
        :host([playing]) [part="play-button-container"] {
            transform: translateY(-200%) translateX(-50%);
            opacity: 0;
        }
        [part="default-icon"] {
            border-radius: 100%;
            width: 48px;
            height: 48px;
            line-height: 48px;
            text-align: center;
            display: block;
            background: rgba(var(--color-main-rgb), 0.75);
            color: var(--color-back);
            transition: background .5s ease;
            &:hover {
                background: var(--color-main);
            }
        }
        [part="default-icon"]::before {
            content: "▶";
            font-family: 'Arial', sans-serif;
        }
        [part="default-cover"] {
            display: block;
            width: 100%;
            aspect-ratio: 4 / 3;
            /* @todo */
            background: repeating-linear-gradient(45deg, black 0px 20px, #222222 20px 40px);
            margin: 0;
        }
        </style>
        <div part="wrapper">
            <div part="click-target">
                <span part="play-button-container">
                    <slot name="play-button">
                        <span part="default-icon"></span>
                    </slot>
                </span>
            </div>
            <div part="cover"><slot name="cover"><figure part="default-cover"></figure></slot></div>
            <div part="internal-player">
                <slot></slot>
            </div>
        </div>
        `;
        customElements.define('base-audio-player', class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }
            get audioElement() {
                const defaultSlot = this.shadowRoot.querySelector('slot:not([name])');
                const children = defaultSlot.assignedElements({flatten: true});
                for (const child of children) {
                    if (child instanceof HTMLAudioElement) {
                        return child;
                    }
                    if (typeof child.play === "function" && typeof child.pause === "function") {
                        // already defined video component
                        return child;
                    }
                    if (!child.matches(':defined') && child.tagName.toLowerCase().indexOf('audio') > -1) {
                        // this must be a audio component that is not defined yet, we simply assume this is going to happen
                        return child;
                    }
                }
                return null;
            }
            connectedCallback() {
                if (this.hasAttribute('playing')) {
                    this.removeAttribute('playing');
                }
                const audio = this.audioElement;
                if (audio) {
                    audio.addEventListener('play', event => {
                        if (this.getAttribute('playing') !== 'playing') {
                            this.setAttribute('playing', 'playing');
                        }
                    });
                    audio.addEventListener('pause', event => {
                        if (this.getAttribute('playing')) {
                            this.removeAttribute('playing');
                        }
                    });
                }
                if (audio instanceof HTMLAudioElement) {
                    audio.controls = false;
                    audio.addEventListener('play', () => {
                        audio.controls = true;
                    });
                    audio.addEventListener('pause', () => {
                        if (!this.matches(':focus-within')) {
                            audio.controls = false;
                        }
                    });
                }
                this.shadowRoot.querySelector('[part="click-target"]').addEventListener('click', this.handleClickEvent.bind(this));
            }
            handleClickEvent(event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                if (this.hasAttribute('playing')) {
                    this.pause();
                } else {
                    this.play();
                }
            }
            play() {
                this.audioElement?.play();
                this.setAttribute('playing', 'playing');
            }
            pause() {
                this.audioElement?.pause();
                this.removeAttribute('playing');
            }
        });
    }
});
